var _path, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_angular_1185_5501_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.032 -0.032 0 32 32)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1031.25,
    y: -1031.25,
    width: 2062.5,
    height: 2062.5
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(217, 217, 217, 0) 0deg,rgba(44, 39, 104, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32ZM7.48129 32C7.48129 45.5413 18.4587 56.5187 32 56.5187C45.5413 56.5187 56.5187 45.5413 56.5187 32C56.5187 18.4587 45.5413 7.48129 32 7.48129C18.4587 7.48129 7.48129 18.4587 7.48129 32Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":0.54901963472366333,\"b\":0.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.85098040103912354,\"g\":0.85098040103912354,\"b\":0.85098040103912354,\"a\":0.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":1.0,\"g\":0.54901963472366333,\"b\":0.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.85098040103912354,\"g\":0.85098040103912354,\"b\":0.85098040103912354,\"a\":0.0},\"position\":1.0}],\"transform\":{\"m00\":3.9188699282725371e-15,\"m01\":-64.0,\"m02\":64.0,\"m10\":64.0,\"m11\":3.9188699282725371e-15,\"m12\":-3.9188699282725371e-15},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.8935,
    cy: 60.2665,
    r: 3.73333,
    fill: "#2C2768"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_angular_1185_5501_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32ZM7.48129 32C7.48129 45.5413 18.4587 56.5187 32 56.5187C45.5413 56.5187 56.5187 45.5413 56.5187 32C56.5187 18.4587 45.5413 7.48129 32 7.48129C18.4587 7.48129 7.48129 18.4587 7.48129 32Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.d48ea27a6671604dc4ad9df41e4cdff4.svg";
export { ForwardRef as ReactComponent };